export default "__VITE_ASSET__CR97FRL$__"